<ng-container *ngIf="user?.runner?.is_premium !== 1">
  <a mat-raised-button (click)="openCountdown()"><span>Betrail PREMIUM</span></a>
</ng-container>
